import { render, staticRenderFns } from "./tenant-settings-loader.vue?vue&type=template&id=c94d5582&scoped=true&"
import script from "./tenant-settings-loader.ts?vue&type=script&lang=ts&"
export * from "./tenant-settings-loader.ts?vue&type=script&lang=ts&"
import style0 from "./tenant-settings-loader.scss?vue&type=style&index=0&id=c94d5582&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94d5582",
  null
  
)

export default component.exports